document.addEventListener('DOMContentLoaded', function() {
    scrollObserve('.p-about-story__section1', '0');
    scrollObserve('.p-about-story__section2', '1');
    scrollObserve('.p-about-story__section3', '2');
});

function scrollObserve(val, i) {
    const el = document.querySelector(val);
    const cb = function(entries) {

        entries.forEach(entry => {
            if(entry.isIntersecting) {
                entry.target.parentNode.previousElementSibling.children[i].classList.add('is-active');
            } else {
                entry.target.parentNode.previousElementSibling.children[i].classList.remove('is-active');
            }
        });
    }

    const options = {
        rootMargin: "50% 0px -50% 0px"
    };
    const io = new IntersectionObserver(cb, options);
    io.observe(el);
}